import { IVisitorInformation, IVisitorProvider } from 'core/model/interfaces/visitor.interface';
import { getAppInstanceId } from 'core/utils/app-instance-id.utils';

export class FingerprintProvider implements IVisitorProvider {
  private readonly id: string | null;

  constructor() {
    this.id = getAppInstanceId();
  }

  async getInformation(): Promise<IVisitorInformation> {
    return { id: this.id };
  }
}
